export const smallMin = '0px';
export const smallMax = '480px';
export const mediumMin = '481px';
export const mediumMax = '960px';
export const largeMin = '961px';
export const largeMax = '1600px';
export default {
  smallMin,
  smallMax,
  mediumMin,
  mediumMax,
  largeMin,
  largeMax
};